import {
  ToolIconFrame,
  toolIconPrimary,
  toolIconSecondary,
  type ToolIconProps
} from './ToolIconFrame';

export function SerpToolsIcon(props: ToolIconProps) {
  return (
    <ToolIconFrame {...props}>
      <rect
        x="7"
        y="8"
        width="34"
        height="32"
        rx="5"
        fill="none"
        stroke={toolIconPrimary}
        strokeWidth="3"
      />
      <path
        d="M7 17.5H41"
        fill="none"
        stroke={toolIconPrimary}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12.5" cy="12.8" r="1.4" fill={toolIconPrimary} />
      <circle cx="17" cy="12.8" r="1.4" fill={toolIconPrimary} />
      <circle cx="21.5" cy="12.8" r="1.4" fill={toolIconPrimary} />
      <circle cx="13" cy="26" r="2.4" fill={toolIconSecondary} />
      <path
        d="M19 26H35"
        fill="none"
        stroke={toolIconSecondary}
        strokeWidth="3.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="13" cy="34" r="2.4" fill={toolIconPrimary} />
      <path
        d="M19 34H31"
        fill="none"
        stroke={toolIconPrimary}
        strokeWidth="3.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </ToolIconFrame>
  );
}
